import { render, staticRenderFns } from "./TableGreenAsset.vue?vue&type=template&id=565f89fa&scoped=true"
import script from "./TableGreenAsset.vue?vue&type=script&lang=js"
export * from "./TableGreenAsset.vue?vue&type=script&lang=js"
import style0 from "./TableGreenAsset.vue?vue&type=style&index=0&id=565f89fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f89fa",
  null
  
)

export default component.exports